import * as React from "react";
import {connect} from "react-redux";
import {Action, Dispatch} from "redux";

import {Project} from "../../domain/model/project";

import {createCustomerProjectActionCreator} from "../action/customer_project_action";
import {createCustomerProjectDispatcher, ICustomerProjectDispatcher,} from "../dispatcher/customer_project_dispatcher";
import {AppState} from "../store/app_state";
import {CustomerProjectState} from "../store/customer_project_state";

import CustomerProjectComponent from "../component/customer/project/customer_project";
import {CreateEntryByCustomerRequest, GetProjectByCustomerRequest,} from "../request/project_request";
import {AuthState} from "../store/auth_state";

interface IProps {
    state: CustomerProjectState;
    authState: AuthState;
    dispatcher: ICustomerProjectDispatcher;
    history: any;
    location: any;
    match: any;
}

interface IState {
    isEntry: boolean;
    isBookmark: boolean;
    isInit: boolean;
}

export class CustomerProject extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isEntry: false,
            isBookmark: false,
            isInit: true,
        };
    }

    public componentDidMount() {
        const projectId: string = this.props.match.params.projectId;
        const req: GetProjectByCustomerRequest = new GetProjectByCustomerRequest();
        req.projectId = projectId;

        this.props.dispatcher.getProject(req);
    }

    public componentDidUpdate(prevProps: IProps) {
        const projectId: string = this.props.state.project
            ? this.props.state.project.id
            : "";
        const entryProjects: Project[] = this.props.state.entryProjects
            ? this.props.state.entryProjects
            : [];

        const _isEntry: boolean = this.checkEntry(projectId, entryProjects);
        if (this.state.isEntry !== _isEntry) {
            this.setState({
                isEntry: _isEntry,
            });
        }
        const location = this.props.location;
        const params = new URLSearchParams(location.search);
        const from_message_rooms = params.get("from_message_rooms");

        const project = this.props.state.project;
        const user = this.props.authState.user;
        if (!this.state.isEntry && _isEntry && project && user && from_message_rooms !== "1") {
            window.open(
                `/customer/message/${project.id}/${user.customer!.id}/${
                    project.companyID
                }`,
                "_blank"
            );
        }

        // init処理の終了
        const isInitFinished: boolean =
            this.state.isInit &&
            !this.props.state.isLoading &&
            prevProps.state.isLoading;
        if (isInitFinished) {
            return this.setState({isInit: false});
        }
    }

    public render(): JSX.Element {
        const {authState} = this.props;
        const {isInit, isEntry} = this.state;
        const {project, company, isLoading} = this.props.state;

        const customer = authState.user ? authState.user.customer : null;

        return (
            <CustomerProjectComponent
                isInit={isInit}
                isLoading={isLoading}
                project={project}
                company={company}
                customer={customer}
                handleCreateEntry={this.handleCreateEntry}
                isEntry={isEntry}
            />
        );
    }

    private checkEntry = (
        projectId: string,
        entryProjectList: Project[]
    ): boolean => {
        let res: boolean = false;

        entryProjectList.map((item: Project) => {
            if (item.id === projectId) {
                res = true;
            }
        });

        return res;
    };

    private handleCreateEntry = () => {
        const projectId: string = this.props.match.params.projectId;
        const req: CreateEntryByCustomerRequest =
            new CreateEntryByCustomerRequest();
        req.projectId = projectId;
        this.props.dispatcher.createEntry(req);
    };
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.customerProjectReducer,
        authState: state.authReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createCustomerProjectDispatcher(
            dispatch,
            createCustomerProjectActionCreator()
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerProject);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_project_container.tsx